<template>
	<el-container>
		<el-main>
			<div style="width: 90%;margin-bottom: 0px;display: flex;justify-content: space-between;height: 14px;">
				<div>
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item class="item_font">开口机器人</el-breadcrumb-item>
						<el-breadcrumb-item><span class="item_font">多话术模式</span></el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>

			<div style="margin-top: 30px;">
				<el-button type="text" size="mini" style="margin-right: 12px;color: orangered;">请先选择科室</el-button>
				<el-select v-model="department" size="mini" placeholder="请选择科室" @change="changeDep" style="margin-right: 12px;">
					<el-option v-for="(item , index) in departmentList" :key="index" :label="item.name" :value="item.depType"></el-option>
				</el-select>

				<el-button type="text" size="mini" style="margin-right: 12px;color: orangered;">请先选择节点名称</el-button>
				<el-select v-model="node" filterable size="mini" placeholder="请选择节点名称" @change="changeNode" style="margin-right: 12px;">
					<el-option v-for="(item , index) in nodeData" :key="index" :label="item.nodeName" :value="item.nodeName"></el-option>
				</el-select>

				<el-button v-if="mode == 1" type="text" size="mini" style="margin-right: 12px;color: orangered;">请先选择映射节点名称</el-button>
				<el-select v-if="mode == 1" v-model="toNode" filterable size="mini" placeholder="请选择映射节点名称" @change="changeNode" style="margin-right: 12px;">
					<el-option v-for="(item , index) in nodeData" :key="index" :label="item.nodeName" :value="item.nodeName"></el-option>
				</el-select>
				<el-button  type="text" size="mini" style="margin-right: 32px;color: orangered;" @click="resetClick()">重置</el-button>
				<el-radio-group v-model="mode">
					<el-radio :label="0">自定义</el-radio>
					<el-radio :label="1">映射</el-radio>
				</el-radio-group>
			</div>

			<div style="margin-top: 30px;">
				<el-row :gutter="50">
					<el-col :span="18">
						<el-table
							v-if="mode == 0"
							:data="utterData"
							border
							style="width: 100%"
							resizable
							ref="utterTableRef"
							:highlight-current-row="true"
							:max-height="maxHeight()"
							class="tableBox"
							v-loading="loading"
						>
							<el-table-column
								label="时间(s)"
								align="center"
								width="80px"
							>
								<template slot-scope="scope">
									<el-input v-model="scope.row.sec" @blur="inputTimeBlur(scope.row)" @focus="handleFocus(scope.row.sec)" placeholder="1"></el-input>
								</template>
							</el-table-column>

							<el-table-column
								label="话术"
								align="center"
								width="700px"
							>
								<template slot-scope="scope">
									<el-input v-model="scope.row.content" @blur="inputContentBlur(scope.row)" @focus="handleFocus(scope.row.content)"  placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>

							<el-table-column
								label="选项"
								align="center"
							>
								<template slot-scope="scope">
									<el-input v-model="scope.row.suggest" @blur="inputSuggestBlur(scope.row)" @focus="handleFocus(scope.row.suggest)" placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>

							<el-table-column
								label="排序"
								align="center"
								width="60px"
							>
								<template slot-scope="scope">
									<el-input v-model="scope.row.sort" @blur="inputSortBlur(scope.row)" @focus="handleFocus(scope.row.sort)" placeholder="0"></el-input>
								</template>
							</el-table-column>
							<el-table-column
								label="操作"
								align="center"
								width="60px"
							>
								<template slot-scope="scope">
									<!-- <el-button @click="toEditUtter(scope.row)" type="text" size="small" class="item_font">编辑</el-button> -->
									<el-button @click="toDel(scope.row)" type="text" size="small" class="item_font">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-button type="primary" style="width: 80%;margin-left: 10%;margin-top: 30px;" v-if="mode == 0" @click="addUtter()">添加话术</el-button>
						<!-- <el-button type="primary" style="width: 40%;margin-left: 4%;margin-right: 8%;margin-top: 30px;" v-if="mode == 0" @click="handleDrop()">保存排序</el-button> -->
						<el-button type="primary" style="width: 80%;margin-left: 10%;margin-top: 30px;" v-if="mode == 1" @click="addMap()">确认映射</el-button>
					</el-col>
					<el-col :span="6">
						<el-table
							:data="nodeData"
							border
							style="width: 100%"
							resizable
							ref="mapTableRef"
							:highlight-current-row="true"
							:max-height="maxHeight()"
							class="tableBox"
							v-loading="loading"
						>
							<el-table-column
								label="节点"
								align="center"
								prop="nodeName"
							>
							</el-table-column>

							<el-table-column
								label="映射"
								align="center"
								prop="mappingTarget"
							>
							</el-table-column>

							<el-table-column
								label="操作"
								align="center"
								width="60px"
							>
								<template slot-scope="scope">
									<el-button @click="editMap(scope.row)" type="text" size="small" class="item_font">编辑</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</div>

			<el-dialog :title="mapDialogTitle" :visible.sync="mapFormVisible" :close-on-click-modal="false">
				<el-form :model="mapForm">
					<el-form-item label="节点" label-width="200px">
						<el-select v-model="mapForm.nodeName" placeholder="请选择节点">
							<el-option v-for="(item , index) in nodeData" :key="index" :label="item.nodeName" :value="item.nodeName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="映射节点" label-width="200px">
						<el-select v-model="mapForm.mappingTarget" placeholder="请选择映射节点">
							<el-option v-for="(item , index) in nodeData" :key="index" :label="item.nodeName" :value="item.nodeName"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="mapFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="addMap">确 定</el-button>
				</div>
			</el-dialog>

			<el-dialog :title="utterDialogTitle" :visible.sync="utterFormVisible" :close-on-click-modal="false">
				<el-form :model="utterForm">
					<el-form-item label="话术" label-width="100px">
						<el-input v-model="utterForm.content" placeholder="请输入内容"></el-input>
					</el-form-item>
					<el-form-item label="选项" label-width="100px">
						<el-input v-model="utterForm.suggest" placeholder="请输入内容"></el-input>
					</el-form-item>
					<el-form-item label="节点" label-width="100px">
						<el-select v-model="utterForm.nodeName" placeholder="请选择节点">
							<el-option v-for="(item , index) in nodeData" :key="index" :label="item.nodeName" :value="item.nodeName"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="映射" label-width="100px">
						<el-select v-model="utterForm.mappingTarget" placeholder="请选择映射节点">
							<el-option v-for="(item , index) in nodeData" :key="index" :label="item.nodeName" :value="item.nodeName"></el-option>
						</el-select>
					</el-form-item> -->

					<el-form-item label="排序" label-width="100px">
						<el-input placeholder="请输入排序" v-model="utterForm.sort" >
						</el-input>
					</el-form-item>
					<el-form-item label="时间" label-width="100px">
						<el-input placeholder="请输入时间" v-model="utterForm.sec" >
							<template slot="append">秒</template>
						</el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="utterFormVisible = false">取 消</el-button>
					<el-button type="primary" @click="editUtter">确 定</el-button>
				</div>
			</el-dialog>
		</el-main>
	</el-container>
</template>

<script>
	import {MessageBox} from 'element-ui';
	import Sortable from 'sortablejs';
	import { maxHeight } from "../../utils/tableHeight";
	export default {
		name: 'Multimodeutter',
		data() {
			return {
				userId: this.util.getLocalAccount().id,
				myHeaders: {
					Authorization: localStorage.getItem("token")
				},
				departmentList: [],
				department: 1,
				utterData: [],
				nodeData: [],
				node:'',
				toNode:'',
				loading: false,
				mode:0,
				mapFormVisible:false,
				mapForm: {
					nodeName:undefined,
					mappingTarget:undefined,
					depType:undefined,
				},
				mapDialogTitle:'添加映射',
				utterFormVisible:false,
				utterForm: {
					sec:1,
					delayTime:undefined,
					depType:undefined,
					content:undefined,
					suggest:undefined,
					id:undefined,
					nodeName:undefined,
					mappingTarget:undefined,
					sort:undefined,
				},
				utterDialogTitle:'添加话术',
				currentValue: '',
				dragItem: null,
			}
		},
		mounted() {
			this.getDepartmentList()
			this.querySelect()
			//this.initSortable()
		},
		watch: {
			value: function(newVal, oldVal) {
				console.log("value", newVal, oldVal)
			},
		},
		methods: {

			maxHeight,

			initSortable() {
				const tableEl = this.$refs.utterTableRef.$el.querySelector('.el-table__body-wrapper tbody');
				Sortable.create(tableEl, {
					onEnd: (evt) => {
						const { oldIndex, newIndex } = evt;
						// 从原数组中移除被拖拽的元素
						const draggedItem = this.utterData.splice(oldIndex, 1)[0];
						// 将被拖拽的元素插入到新的位置
						this.utterData.splice(newIndex, 0, draggedItem);
						//this.handleDrop();
					}});
			},
	
			// 获取科室列表
			async getDepartmentList() {
				var api = "/manager/depType/getDepType"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {

					},
				})
				console.log("*****querySelect getDepType*****", response)
				this.departmentList = response.data
			},

			// 获取话术
			async querySelect() {
				this.loading = true;
				var api = "/manager/multiModeUtter/getUtters";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
                        depType:this.department,
						nodeName:this.node
					},

				})
				console.log("response", response)
				if (response.data.length == 0) {
					this.$message.success("该科室暂无数据，请选择其他科室");
				} else {
					response.data.utterList.forEach((item) => {
						item.sec = item.delayTime/1000 + '';
					});
					this.utterData = response.data.utterList;
					this.nodeData = response.data.nodeNamelist;
					
				}
				this.loading = false;
			},

			resetClick() {
				this.node = undefined;
				this.toNode = undefined;
				this.querySelect()
			},

			handleFocus(currentValue) {
				console.log('Current value on focus:', currentValue);
				this.currentValue = currentValue;
			},

			onInput(event) {
				this.utterForm.sec = event.target.value.replace(/[^0-9]/g, '');
			},
			
			async handleDrop() {
				var UtterList = []
				var sort = 0;
				this.utterData.forEach((item)=>{
					UtterList.push({sort:sort,id:item.id})
					sort ++;
				});

				var api = "/manager/multiModeUtter/updateUtter"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						depType:this.department,
						UtterList:UtterList
					},

				});
				if (response.resultCode === "10000") {
					//this.$message.success('排序成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}

			},

			//选择科室
			changeDep(val) {
				console.log("changeDep", val)
				this.node = undefined;
				this.toNode = undefined;
				this.querySelect()
			},

			//选择节点
			changeNode(val) {
				console.log("changeNode", val)
				this.querySelect()
			},

			editMap(row) {
				console.log("changeNode", row)
				this.mapForm.nodeName =  row.nodeName;
				this.mapForm.mappingTarget =  row.mappingTarget;
				this.mapForm.depType =  row.depType;
				this.mapFormVisible = true;
				
			},


			addUtter() {
				this.utterForm.content = undefined;
				this.utterForm.suggest = undefined;
				this.utterForm.sec = 1;
				this.utterForm.delayTime = 1000;
				this.utterForm.depType = this.department;
				this.utterForm.id = undefined;
				this.utterForm.nodeName = undefined;
				this.utterForm.mappingTarget = undefined;
				this.utterFormVisible = true;
				this.utterDialogTitle = '添加话术';
			},

			toEditUtter(row) {
				this.utterForm.content = row.content;
				this.utterForm.suggest = row.suggest;
				this.utterForm.sec = row.delayTime/1000;
				this.utterForm.delayTime = row.delayTime;
				this.utterForm.depType = row.depType;
				this.utterForm.id = row.id;
				this.utterForm.nodeName = row.nodeName;
				this.utterForm.mappingTarget =  row.mappingTarget;
				this.utterFormVisible = true;
				this.utterDialogTitle = '编辑话术';
			},

			async inputContentBlur(row) {
				if(row.content == this.currentValue  || row.content == undefined || row.content == '') return;
				var api = "/manager/multiModeUtter/updateUtter"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						depType:row.depType,
						UtterList:[{
							id:row.id,
							content:row.content,
						}]
					},

				});
				if (response.resultCode === "10000") {
					this.$message.success('修改成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},

			async inputSortBlur(row) {
				if(row.sort == this.currentValue || row.sort == undefined || row.sort == '') return;
				var api = "/manager/multiModeUtter/updateUtter"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						depType:row.depType,
						UtterList:[{
							id:row.id,
							sort:row.sort,
						}]
					},

				});
				if (response.resultCode === "10000") {
					this.$message.success('修改成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},

			async  inputSuggestBlur(row) {
				if(row.suggest == this.currentValue  || row.suggest == undefined ) return;
				var api = "/manager/multiModeUtter/updateUtter"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						depType:row.depType,
						UtterList:[{
							id:row.id,
							suggest:row.suggest,
						}]
					},

				});
				if (response.resultCode === "10000") {
					this.$message.success('修改成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},

			async inputTimeBlur(row) {
				if(row.sec == this.currentValue || row.sec == 0 || row.sec == undefined || row.sec == '') return;
				var api = "/manager/multiModeUtter/updateUtter"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						depType:row.depType,
						UtterList:[{
							id:row.id,
							delayTime:row.sec * 1000,
						}]
					},

				});
				if (response.resultCode === "10000") {
					this.$message.success('修改成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},

			async editUtter() {
				var api = "/manager/multiModeUtter/updateUtter"
				if(this.utterForm.id == undefined){
					api = "/manager/multiModeUtter/insertUtters"
				}
				if(this.utterForm.content == undefined){
					this.$message.info('请输入话术!')
					return
				}
				if(this.utterForm.nodeName == undefined){
					this.$message.info('请选择话术节点!')
					return
				}
				if(this.utterForm.delayTime == undefined){
					this.$message.info('请设置时间!')
					return
				}
				this.utterFormVisible = false;
				var lastItem = this.utterData[this.utterData.length - 1];
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						depType:this.utterForm.depType,
						UtterList:[{
							id:this.utterForm.id,
							content:this.utterForm.content,
							suggest:this.utterForm.suggest,
							nodeName:this.utterForm.nodeName,
							mappingTarget:this.utterForm.mappingTarget,
							delayTime:this.utterForm.sec * 1000,
							sort:lastItem.sort +1
						}]
					},

				});
				if (response.resultCode === "10000") {
					this.$message.success('添加成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},

			async addMap(type = 0) {
				this.mapFormVisible = false;
				var api = "/manager/multiModeUtter/updateUttersMapping"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						nodeName:type == 0?this.node:this.mapForm.nodeName,
						mappingTarget:type == 0?this.toNode:this.mapForm.mappingTarget,
						depType:type == 0?this.department:this.mapForm.depType,
					},

				});
				if (response.resultCode === "10000") {
					this.$message.success('映射成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},

			toDel(row) {
				MessageBox.alert("是否确认删除", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
				}).then(() => {
					this.delUtter(row)
				}).catch(() => {
					this.$message.info('取消删除!')
				})
			},
			async delUtter(row){
				var api = "/manager/multiModeUtter/delUtter"
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id:row.id
					},

				});
				if (response.resultCode === "10000") {
					this.$message.success('删除成功')
					this.querySelect()
				} else {
					this.open2(response.desc)
				}
			},
		
			open1(info) {
				console.log(info)
			},
			open2(info) {
				const text = info + ' 保存失败 '
				this.$message.error(text)
			},

		}
	}
</script>

<style scoped="scoped">
	.radios {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		height: 30px;
		line-height: 30px;
		margin-top: 30px;
		font-size: 14px;
	}

	.buttons1 {
		text-align: right;
	}

	.dialog {
		height: 350px;
	}

	.el-radio-button__inner {
		@include change_size($font_size_normal)
	}

	.el-table__body-wrapper tbody tr {
		cursor: move;
	}
</style>
